<div class="container">
    <p>Current share price: <b>333.45 R</b></p>
    <p>JSE code: <b>FRT</b></p>
    <p>Share movement: <b>+0.00</b></p>
    <p>Current share price: <b>333.45 R</b></p>
    <p>JSE code: <b>FRT</b></p>
    <p>Share movement: <b>+0.00</b></p>
</div>